/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Sledování doručení`
};

const da_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Ordresporing`
};

const de_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Sendungsverfolgung`
};

const en_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Order tracking`
};

const es_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Seguimiento del pedido`
};

const fr_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Suivi de livraison`
};

const hu_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Szállítás nyomon követése`
};

const it_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Tracciamento spedizione`
};

const nl_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Bestelling volgen`
};

const pl_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Śledzenie zamówienia`
};

const pt_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Rastreamento de pedido`
};

const sv_order_tracking = /** @type {(inputs: {}) => string} */ () => {
	return `Leveransspårning`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const order_tracking = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.order_tracking(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("order_tracking", locale)
	if (locale === "cs") return cs_order_tracking(inputs)
	if (locale === "da") return da_order_tracking(inputs)
	if (locale === "de") return de_order_tracking(inputs)
	if (locale === "en") return en_order_tracking(inputs)
	if (locale === "es") return es_order_tracking(inputs)
	if (locale === "fr") return fr_order_tracking(inputs)
	if (locale === "hu") return hu_order_tracking(inputs)
	if (locale === "it") return it_order_tracking(inputs)
	if (locale === "nl") return nl_order_tracking(inputs)
	if (locale === "pl") return pl_order_tracking(inputs)
	if (locale === "pt") return pt_order_tracking(inputs)
	return sv_order_tracking(inputs)
};